<template>
  <div class="mb-4 grid grid-cols-[auto_1fr] justify-end">
    <div class="flex items-center justify-between gap-2">
      <span class="text-black-70 text-base md:hidden">
        {{ $t('pdp.main_order_number') }}
        <span data-test-id="product-order-number">{{
          productOrderNumber
        }}</span>
      </span>
    </div>
    <div
      class="row-1 md:row-2 col-[1/span_2] row-[2/span_1] mt-1 flex items-center justify-end md:col-[1/span_1] md:row-[1/span_1] md:mt-0 md:justify-start"
    >
      <Button
        id="add-to-basket"
        data-test-id="add-item-to-basket-button"
        no-padding
        type="primary"
        class="w-96 rounded-sm py-2 transition-colors duration-200"
        :class="[
          {
            'cursor-not-allowed': product.isSoldOut,
            '!bg-red hover:!bg-red': showSizeError,
          },
        ]"
        :title="title"
        ignore-capitalisation
        data-qa="add-to-cart"
        @click="handleAddToBasketClick"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <span v-if="showSizeError">
          {{ $t('pdp.size_picker.select_size_error') }}
        </span>
        <span v-else-if="showBackInStockButton">
          {{ $t('back_in_stock_subscription_form.cta_button_label') }}
        </span>
        <span v-else-if="showAlreadyInCartButton">
          {{ $t('pdp.already_in_cart_label') }}
        </span>
        <span v-else>
          {{ $t('pdp.add_label') }}
        </span>
      </Button>
    </div>
    <ClientOnly>
      <button
        data-test-id="add-item-to-wishlist-button"
        class="ml-auto w-fit cursor-pointer rounded-full bg-gold-20 p-2 transition-transform active:scale-95 md:col-[2/span_1] md:row-[1/span_1] md:ml-2"
        data-qa="add-to-wishlist"
        :title="wishlistAriaLabel"
        :aria-label="wishlistAriaLabel"
        @click="handleToggleWishlist"
      >
        <IconHeart v-if="!isInWishlist" class="size-6" />
        <IconHeartFull v-if="isInWishlist" class="size-6" />
      </button>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import {
  useBasketHandling,
  type UseBasketHandlingProps,
} from '../../../../../../../layers/base/composables/useBasketHandling'

const props = defineProps<UseBasketHandlingProps>()

const {
  showSizeError,
  showBackInStockButton,
  showAlreadyInCartButton,
  canPurchase,
  isInWishlist,
  handleAddToBasketClick,
  handleMouseEnter,
  handleMouseLeave,
  handleToggleWishlist,
} = useBasketHandling(props)

const i18n = useI18n()

const title = computed(() => {
  return !canPurchase ? i18n.t('badge_labels.sold_out') : ''
})

const wishlistAriaLabel = computed(() => {
  return isInWishlist.value
    ? i18n.t('pdp.remove_from_wishlist')
    : i18n.t('pdp.add_to_wishlist')
})
</script>
